import { h } from 'preact'

type ColSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
type ColOffsetSize = 0 | ColSize

interface Props extends h.JSX.HTMLAttributes<HTMLDivElement> {
    xs?: ColSize
    xsOffset?: ColOffsetSize
    sm?: ColSize
    smOffset?: ColOffsetSize
    md?: ColSize
    mdOffset?: ColOffsetSize
    lg?: ColSize
    lgOffset?: ColOffsetSize
    xl?: ColSize
    xlOffset?: ColOffsetSize
}

const Col: preact.FunctionalComponent<Props> = ({
    xs,
    xsOffset,
    sm,
    smOffset,
    md,
    mdOffset,
    lg,
    lgOffset,
    xl,
    xlOffset,
    children,
    ...rest
}: Props) => {
    const colClass = []

    if (xs) {
        colClass.push(`col-xs-${xs}`)
    }

    if (xsOffset) {
        colClass.push(`col-xs-offset-${xsOffset}`)
    }

    if (sm) {
        colClass.push(`col-sm-${sm}`)
    }

    if (smOffset) {
        colClass.push(`col-sm-offset-${smOffset}`)
    }

    if (md) {
        colClass.push(`col-md-${md}`)
    }

    if (mdOffset) {
        colClass.push(`col-md-offset-${mdOffset}`)
    }

    if (lg) {
        colClass.push(`col-lg-${lg}`)
    }

    if (lgOffset) {
        colClass.push(`col-lg-offset-${lgOffset}`)
    }

    if (xl) {
        colClass.push(`col-xl-${xl}`)
    }

    if (xlOffset) {
        colClass.push(`col-xl-offset-${xlOffset}`)
    }

    if (colClass.length === 0) {
        colClass.push('col-xs')
    }

    const props = {
        ...rest,
        class: rest.class ? `${colClass.join(' ')} ${rest.class}` : colClass.join(' '),
    }

    return <div {...props}>{children}</div>
}

export default Col
